import React, { useEffect, useState } from "react";
import API from "../../config/axios";
import { toastErrorMessage } from "../../utils/utils";
import { api_paths } from "../../config/api.paths";
import { SET_LOADING } from "../../redux/user";
import { useDispatch } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";

const TermsAndConditions = () => {
  const [page, setPage] = useState();
  const dispatch = useDispatch();

  const getPageDetails = async (identifier) => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(`${api_paths.GET_CMS_PAGE}${identifier}`);
      if (response?.data?.payload?.result) {
        setPage(response?.data?.payload?.result);
      }
    } catch (error) {
      console.log(error);
      toastErrorMessage(error?.response?.data?.message);
    }
    dispatch(SET_LOADING(false));
  };

  useEffect(() => {
    getPageDetails("TERM_CONDITION"); // privacy_policy term_condition about_us
    //eslint-disable-next-line
  }, []);

  return (
    <Container className="termsandcondition-section">
      <Row className="text-center pt-4 pb-2 privacy-section">
        <Col lg={12}>
          <h1 className="mb-3 h1 text-main">Terms And Conditions</h1>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col lg={12} className="px-3">
          <div
            className="cms_pages"
            dangerouslySetInnerHTML={{ __html: page?.content }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsAndConditions;
